module.exports = __webpack_public_path__ + "img/headphones-02.8ed2e541.svg";